(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edifier-bby-video-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('edifier-bby-popup')) {
    customElements.define('edifier-bby-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.section = document.getElementById('shopify-section-' + this.dataset.sectionId);
        if (!this.dialog || !this.section) return;
        this.section.querySelectorAll('[data-edifier-locator-trigger] a, [data-edifier-locator-trigger] button').forEach(trigger => {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', this.dialog.id);
        });
        this.openPopup = event => {
          const trigger = event.target.closest('[data-edifier-locator-trigger] a, [data-edifier-locator-trigger] button');
          if (!trigger || !this.section.contains(trigger)) return;
          event.preventDefault();
          event.stopPropagation();
          if (this.dialog.open) return;
          this.opener = trigger;
          this.dialog.showModal();
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          const searchInput = this.querySelector('input[type="search"]');
          if (searchInput) searchInput.focus();
          else this.querySelector('.edf-bby-dialog__close').focus();
        };
        this.closePopup = () => {
          document.documentElement.style.overflow = this.previousOverflow;
          if (this.opener && this.opener.isConnected) this.opener.focus();
          this.opener = null;
        };
        this.backdropClick = event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        };
        this.section.addEventListener('click', this.openPopup, true);
        this.dialog.addEventListener('close', this.closePopup);
        this.dialog.addEventListener('click', this.backdropClick);
      }
      disconnectedCallback() {
        if (this.dialog && this.dialog.open) {
          this.dialog.close();
          this.closePopup();
        }
        if (this.section) this.section.removeEventListener('click', this.openPopup, true);
        if (this.dialog) {
          this.dialog.removeEventListener('close', this.closePopup);
          this.dialog.removeEventListener('click', this.backdropClick);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
